import { render, staticRenderFns } from "./query_tender.vue?vue&type=template&id=71b8e52f&scoped=true"
import script from "./query_tender.vue?vue&type=script&lang=js"
export * from "./query_tender.vue?vue&type=script&lang=js"
import style0 from "./query_tender.vue?vue&type=style&index=0&id=71b8e52f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b8e52f",
  null
  
)

export default component.exports